import { observable } from "mobx";
import { ILayoutElement} from "../_types/interfaces";
import { firstLinks } from "../core/Data/Links";
import { linkService } from "../_services";


export const linksStore = observable({
    Links: [] as Array<ILayoutElement>,
    isLoaded: false,

    get getLinks(): Array<ILayoutElement> {
        if (!linksStore.isLoaded)
            linksStore.loadRoutes();
        return firstLinks.concat(linksStore.Links);
    },
    async loadRoutes() {
        try {
            const response = await linkService.getLinksList();
            linksStore.isLoaded = true;

            linksStore.Links = response.map(l => (
                {
                    link: l.Address,
                    icon: l.Icon, 
                    text: l.Name,
                    newTab: l.NewTab,

                } as ILayoutElement
            ));
        } catch (errors) 
        {
            console.log(errors);
        }
    },
});
